/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Money = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 16" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M21.995 5.01v8.988a2 2 0 0 1-2.003 1.996H5.032a2 2 0 0 1-2.004-1.996v-1.023H2.001a2 2 0 0 1-2.003-1.997V1.989A2 2 0 0 1 2.001-.007h14.961a2 2 0 0 1 2.003 1.996v1.024h1.027a2 2 0 0 1 2.003 1.997zm-5.033 5.968V1.989H2.002v8.989zm3.03-5.968h-1.027v5.968a2 2 0 0 1-2.003 1.997H5.032v1.023h14.96zM7.986 4.984v1h2.991c.551 0 .998.447.998.999v.997a.998.998 0 0 1-.998 1H9.98v.499a.5.5 0 1 1-.997 0v-.5H7.487a.5.5 0 0 1 0-.999h3.49v-.997H7.986a.999.999 0 0 1-.998-.998v-1c0-.551.447-.997.998-.997h.997v-.501a.499.499 0 0 1 .997 0v.5h1.496a.498.498 0 1 1 0 .997z" />
      </g>
    </svg>
  </span>
);

Money.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Money.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Money;
